<template lang="html">
  <div class="promo-code-input flex flex-col gap-2">
    <div class="text-sm font-medium">
      Промокод
    </div>

    <div class="flex flex-wrap gap-2">
      <UInput
        v-model="inputCode"
        class="min-w-0 flex-1 max-sm:min-w-70"
        placeholder="Введите промокод"
        :disabled="props.readonly || props.loading"
        :color="props.error ? 'error' : undefined"
        @keyup.enter="handleApply"
      >
        <template v-if="showClearInputButton" #trailing>
          <UButton
            icon="i-lucide-x"
            size="xs"
            color="neutral"
            variant="ghost"
            aria-label="Очистить промокод"
            @click="handleClearInput"
          />
        </template>
      </UInput>

      <UButton
        v-if="!props.readonly && !activePromoCode"
        :loading="props.loading"
        :disabled="props.loading || !inputCode.trim()"
        @click="handleApply"
      >
        Применить
      </UButton>

      <UButton
        v-if="!props.readonly && activePromoCode"
        color="neutral"
        variant="outline"
        :loading="props.loading"
        :disabled="props.loading"
        @click="emit('clear')"
      >
        Удалить
      </UButton>
    </div>

    <p v-if="props.error" class="text-sm text-error">
      {{ props.error }}
    </p>

    <div
      v-if="props.readonly && activePromoCode && !props.hideSavedPromoCode"
      class="text-sm text-muted"
    >
      Промокод:
      <span class="font-medium text-default">{{ activePromoCode }}</span>
    </div>

    <UAlert
      v-if="hasSavedPromoWithoutSelection"
      color="info"
      variant="soft"
      icon="i-lucide-info"
      title="Выберите товары"
      description="Промокод сохранён. Отметьте товары в корзине, чтобы применить скидку."
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: string
    activePromoCode?: string | null
    error?: string | null
    readonly?: boolean
    loading?: boolean
    hasSavedPromoWithoutSelection?: boolean
    hideSavedPromoCode?: boolean
  }>(),
  {
    readonly: false,
    loading: false,
    hasSavedPromoWithoutSelection: false,
    hideSavedPromoCode: false,
  },
)

const emit = defineEmits<{
  'update:modelValue': [value: string]
  apply: []
  clear: []
}>()

const inputCode = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})

const activePromoCode = computed(() => props.activePromoCode)
const showClearInputButton = computed(
  () => !props.readonly && !props.loading && Boolean(inputCode.value),
)

function handleApply() {
  emit('apply')
}

function handleClearInput() {
  inputCode.value = ''
}
</script>
